import { render, staticRenderFns } from "./c_dashboard_rehber_onay_bekleyenler.vue?vue&type=template&id=190f41ce"
import script from "./c_dashboard_rehber_onay_bekleyenler.vue?vue&type=script&lang=js"
export * from "./c_dashboard_rehber_onay_bekleyenler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports